// src/components/Leave.js
import React, { useEffect, useState } from "react";
import "./LeaveSection.css";

const API   = "https://apiportal.mbsays.com/public/api";
const token = sessionStorage.getItem("authToken");
const me    = JSON.parse(sessionStorage.getItem("user") || "{}");

const HEAD = {
  "Content-Type": "application/json",
  Authorization : `Bearer ${token}`
};

const Leave = () => {
  const [pending, setPending]     = useState([]);
  const [approved, setApproved]   = useState([]);
  const [rejected, setRejected]   = useState([]);
  const [open, setOpen]           = useState(false);
  const [start, setStart]         = useState("");
  const [end, setEnd]             = useState("");
  const [note, setNote]           = useState("");

  const today   = new Date().toISOString().split("T")[0];
  const yrLater = new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString().split("T")[0];
  const fmt     = d => new Date(d).toLocaleDateString("tr-TR");
  const diff    = (s, e) => ((new Date(e) - new Date(s)) / 86400000) + 1;

  // Kullanıcının izinlerini çek
  const loadUserLeaves = async () => {
    const res = await fetch(`${API}/my-vacations`, { headers: HEAD });
    const data = await res.json();
    setPending (data.filter(v => v.status === "pending"));
    setApproved(data.filter(v => v.status === "approved"));
    setRejected(data.filter(v => v.status === "rejected"));
  };

  useEffect(() => { loadUserLeaves(); }, []);

  const sendReq = async e => {
    e.preventDefault();
    if (!start || !end) return alert("Tarih seçin");

    const body = JSON.stringify({ start_date: start, end_date: end, note });
    const res  = await fetch(`${API}/vacations`, {
      method: "POST", headers: HEAD, body
    });

    if (!res.ok) return alert("Gönderilemedi");

    await loadUserLeaves();
    setOpen(false); setStart(""); setEnd(""); setNote("");
  };

  // Bekleyen talebi sil
  const deleteLeave = async id => {
    if (!window.confirm("Bu izin talebini silmek istediğinize emin misiniz?")) return;

    const res = await fetch(`${API}/vacations/${id}`, {
      method: "DELETE",
      headers: HEAD
    });

    if (!res.ok) return alert("Silinemedi");
    await loadUserLeaves();
  };

  // Tablo bileşeni
  const Table = ({ data, status }) => (
    <table className="leave-table">
      <thead>
        <tr>
          <th>Başlangıç</th>
          <th>Bitiş</th>
          <th>Gün</th>
          <th>Durum</th>
          <th>Not</th>
          {status === "pending" && <th>İşlem</th>}
        </tr>
      </thead>
      <tbody>
        {data.map(v => (
          <tr key={v.id}>
            <td>{fmt(v.start_date)}</td>
            <td>{fmt(v.end_date)}</td>
            <td>{v.days_requested ?? diff(v.start_date, v.end_date)}</td>
            <td className={`status ${v.status}`}>{v.status}</td>
            <td>{v.note || "-"}</td>
            {status === "pending" && (
              <td>
                <button onClick={() => deleteLeave(v.id)} className="reject">
                  Sil
                </button>
              </td>
            )}
          </tr>
        ))}
      </tbody>
    </table>
  );

  return (
    <div className="leave-wrapper">
      <h2>İzin Taleplerim</h2>

      <div className="kalan-box">
        <span>Kalan gün:</span>
        <b>{me.vacation_days}</b>
        <button onClick={() => setOpen(true)}>Yeni Talep</button>
      </div>

      {/* Bekleyen */}
      <h3>Bekleyen Talepler</h3>
      {pending.length ? <Table data={pending} status="pending" /> : <p>Bekleyen talep yok</p>}

      {/* Onaylanan */}
      <h3>Onaylanan Talepler</h3>
      {approved.length ? <Table data={approved} status="approved" /> : <p>Onaylı talep yok</p>}

      {/* Reddedilen */}
      <h3>Reddedilen Talepler</h3>
      {rejected.length ? <Table data={rejected} status="rejected" /> : <p>Reddedilen talep yok</p>}

      {/* Yeni Talep Modal */}
      {open && (
        <div className="modal-overlay">
          <div className="modal">
            <h3>Yeni İzin Talebi</h3>
            <form onSubmit={sendReq}>
              <label>Başlangıç</label>
              <input
                type="date"
                value={start}
                min={today}
                max={yrLater}
                onChange={e => setStart(e.target.value)}
                required
              />

              <label>Bitiş</label>
              <input
                type="date"
                value={end}
                min={start || today}
                max={yrLater}
                onChange={e => setEnd(e.target.value)}
                required
              />

              <label>Not</label>
              <textarea
  value={note}
  onChange={e => setNote(e.target.value)}
  required
/>


              <div className="modal-btns">
                <button type="submit" className="approve">Gönder</button>
                <button type="button" className="reject" onClick={() => setOpen(false)}>
                  İptal
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Leave;
